// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginSupportLinks__container___1QEA1","language":"LoginSupportLinks__language___1dzss","selected":"LoginSupportLinks__selected___2XhcB"};